module.exports = {"select":"Seleccionar"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/SelectSystem.json
// module id = 596
// module chunks = 1